export function getColor(val, sextiles){
    let val_fpi =0;
    for(let i=1;i<=5;i++){
        val_fpi = sextiles[i-1]
        if(val<=val_fpi){
            return getRGB_fp(i)
        }
    }
    return getRGB_fp(6)
}

export function getPrecision(carac, mapType) {
    if (carac == "height"){
        if (mapType == "rawMap")
            return 2;
        return 3;
    } else if (carac == "leafWallArea"){
        return 0;
    } else if (carac == "thickness"){
        if (mapType == "rawMap")
            return 2;
        return 3;
    } else if (carac == "tfi"){
        if (mapType == "rawMap")
            return 0;
        return 1;
    } else {
        return 1;
    }
}

export function getRGB_fp(i){
    switch (i) {
        case 1:
            return 'rgb(255, 255, 204)';
        case 2:
            return 'rgb(255, 255, 102)';
        case 3:
            return 'rgb(255, 204, 102)';
        case 4:
            return 'rgb(255, 153, 51)';
        case 5:
            return 'rgb(255, 102, 0)';
        case 6:
            return 'rgb(255, 0, 0)';

        default:
            return 'rgb(0, 0, 0)';
    }
}


export function inRange (x) {
    return this[0] <= x && x < this[1]
}
